<div class="potential-overlap h-100 d-flex flex-column mb-5 overflow-auto" *ngIf="!isLoading">
    <div class="p-4 table-wrapper">
        <app-tco-table [source]="'overlap'" [dataList]="testArray" (onRowSelect)="handleRowSelection($event)"></app-tco-table>
    </div>
    <div class="p-4 pb-0 comparison-wrapper d-flex flex-column">
        <div class="cards-wrapper d-flex pb-3 w-100">

            <!-- BASE -->
            <div class="card-illustrate" style="margin-right: 10px;"
                [ngStyle]="{ 'background': getColor(0).bg, 'border-color': getColor(0).border }">
                <div class="d-flex flex-column">
                    <strong> Test ID: </strong>
                    <strong> {{ baseTestCase?.testId }} </strong>
                </div>
                <div class="d-flex flex-column">
                    <strong>Test Case Name</strong>
                    <span> {{ baseTestCase?.testName }} </span>
                </div>

                <div class="d-flex flex-column mt-2">
                    <span> Test Steps </span>
                    <div *ngIf="baseTestCase.formattedCorStepDesc && baseTestCase.formattedCorStepDesc.length">
                        <div class="step" *ngFor="let step of baseTestCase.formattedCorStepDesc; let y = index"
                            [style.backgroundColor]="highlightStepDifferencesX(step,'base') !== -1 ? '#A5D6A7' : 'transparent'">
                            <ng-container *ngFor="let word of step.split(' ');let j = index">
                                <ng-container
                                    *ngIf="highlightStepDifferencesX(step,'base') !== -1 && isStepNumber(word,j); else afterStep">
                                    {{ word}} <span style="color: red;">({{ highlightStepDifferencesX(step,'base') }})
                                    </span>
                                </ng-container>
                                <ng-template #afterStep>
                                    <span
                                        [style.backgroundColor]="highlightStepDifferencesX(step,'base') !== -1 ? 'transparent' : (highlightFormattedStepDesc(word, j,y,'base') ? '#D7E1FF' : 'transparent')">
                                        {{word}}
                                    </span>
                                    <span *ngIf="j < step.split(' ').length - 1"> </span>
                                </ng-template>

                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-column mt-2">
                    <span> Expected Results </span>
                    <div>
                        <ng-container *ngFor="let word of baseTestCase?.cleanedExpResult.split(' '); let j = index">
                            <span
                                [style.backgroundColor]="highlightExpectedResults(word, j,'base') ? '#D7E1FF' : 'transparent'">
                                {{ word }}
                            </span>

                            <span *ngIf="j < baseTestCase?.cleanedExpResult.split(' ').length - 1"> </span>
                        </ng-container>
                    </div>
                </div>

                <div>

                </div>
            </div>

            <!-- COMPARED  -->
            <div class="card-illustrate rounded-1"
                [ngStyle]="{ 'background': getColor(1).bg, 'border-color': getColor(1).border }">
                <div class="d-flex flex-column">
                    <strong> Test ID: </strong>
                    <strong> {{ comparedTestCase?.testId }} </strong>
                </div>
                <div class="d-flex flex-column">
                    <strong>Test Case Name</strong>
                    <span> {{ comparedTestCase?.testName }} </span>
                </div>

                <div class="d-flex flex-column mt-2">
                    <span> Test Steps </span>
                    <div *ngIf="comparedTestCase.formattedCorStepDesc && comparedTestCase.formattedCorStepDesc.length">
                        <div class="step" *ngFor="let step of comparedTestCase.formattedCorStepDesc; let y = index"
                            [style.backgroundColor]="highlightStepDifferencesX(step,'compare') !== -1 ? '#A5D6A7' : 'transparent'">
                            <ng-container *ngFor="let word of step.split(' ');let j = index">
                                <ng-container
                                    *ngIf="highlightStepDifferencesX(step,'compare') !== -1 && isStepNumber(word,j); else afterStep">
                                    {{ word}} <span style="color: red;">({{ highlightStepDifferencesX(step,'compare')
                                        }}) </span>
                                </ng-container>
                                <ng-template #afterStep>
                                    <span
                                        [style.backgroundColor]="highlightStepDifferencesX(step,'compare') !== -1 ? 'transparent' : (highlightFormattedStepDesc(word, j,y,'compare') ? '#D7E1FF' : 'transparent')">
                                        {{word}}
                                    </span>
                                    <span *ngIf="j < step.split(' ').length - 1"> </span>
                                </ng-template>

                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-column mt-2">
                    <span> Expected Results </span>
                    <div>
                        <ng-container *ngFor="let word of comparedTestCase?.cleanedExpResult.split(' '); let j = index">
                            <span
                                [style.backgroundColor]="highlightExpectedResults(word, j,'compare') ? '#D7E1FF' : 'transparent'">
                                {{ word }}
                            </span>

                            <span *ngIf="j < comparedTestCase?.cleanedExpResult.split(' ').length - 1"> </span>
                        </ng-container>
                    </div>
                </div>

                <div>

                </div>
            </div>

            <!-- <app-comparison-card style="margin-right: 15px; width: 50%;" *ngFor="let item of data; let i = index;" [color]="getColor(i)"></app-comparison-card> -->
        </div>
    </div>

    <div class="legends-wrapper bordered rounded p-3 mx-4 mb-1 d-flex flex-column">
        <div class="legend-content rounded p-1 px-2"> <strong> System Impression: </strong> The similarity score between
            steps description of Test IDs [{{testIdsForSelectedCluster}}] is <strong> {{ testDescriptionSimilarity }}%
            </strong> & Expected Results is <strong> {{ expResultsSimilarity }}% </strong> </div>
        <span class="mt-2">
            <img src="assets/images/virtusa-icons/blue-square.svg" alt="blue">
            Indicates differences in wording between the two cases.
        </span>
        <span class="mt-2">
            <img src="assets/images/virtusa-icons/green-square.svg" alt="blue">
            Represents steps that are the same in both cases but appear in a different sequence.
        </span>
        <span class="mt-2">
            <img src="assets/images/virtusa-icons/number-square.svg" alt="blue">
            Denote the step number of a matching step from the compared test case, highlighting a difference in order.
        </span>
    </div>
    <div class="footer d-flex justify-content-end mt-3">
     <button class="btn-accello-primary-outlined align-items-center mx-2" (click)="goBack()">Back</button>
    </div>
</div>

<div class="h-100 v-center" *ngIf="isLoading">
    <app-loading [text]="'Loading...'"></app-loading>
</div>